export enum ReportTypeEnum
{
    SADT = 1,
    Admissão = 2,
}